export default {
  route: {
    home: 'Home',
    myReward: 'My Rewards',
    userPool: 'User Pool',
    rewardOrders: 'Reward Orders',
    distributorManagement: 'Distributor Management',
    rewardPackageConfig: 'Reward Setup',
    distributorSettlement: 'Distributor Settlement',
    orderManagement: 'Order Management',
    distributorApproval: 'Distributor Approval',
    paymentManagement: 'Payment Management',
    paymentBillDetails: 'Payment Bill Details'
  }
};